<template>
  <v-responsive>
    <v-container fill-height>
      <v-row align="center">
        <v-col>
          <h3 class="display-2 orange--text text--darken-3">
            {{ $t('buddy.jambotron.title') }}
          </h3>
          <span class="title">
            <v-icon color="orange darken-3" large>mdi-alert-circle-outline</v-icon>
            {{ $t('buddy.jambotron.note') }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </v-responsive>
</template>

<script>
export default {
  name: 'no-users-notice'
}
</script>

<style scoped>
</style>
